import { useContext } from 'react';
import { CanvasContext } from 'context/canvas-context/canvas-context';
import { CanvasRect } from 'canvas/canvas-rect/canvas-rect';
import { Layer } from 'layer';
import { SMALL_PADDING } from 'constants/paddings';
import { ToolbarContext } from 'context/toolbar-context/toolbar-context';
import { TOOLS } from 'constants/tools';
import { COLORS } from 'constants/colors';

export function useCreateStickerTool() {
	const { renderer, renderingManager } = useContext(CanvasContext);
	const { setTool } = useContext(ToolbarContext);

	return function ({ pageX, pageY }: MouseData) {
		if (renderer && renderingManager) {
			const canvasSticker = new CanvasRect({
				x: pageX,
				y: pageY,
				w: 200,
				h: 200,
				color: COLORS.STICKER_BACKGROUND,
				shadowColor: 'rgba(0, 0, 0, 0.3)',
				shadowOffsetY: 10,
				shadowOffsetX: 3,
				shadowBlur: 5,
				scale: 1,
			});
			const layer = new Layer({
				x: pageX - SMALL_PADDING,
				y: pageY - SMALL_PADDING,
				w: 200 + 10,
				h: 200 + 10,
				scale: 1,
			});
			layer.addChild(canvasSticker);
			renderingManager.add(layer);
			setTool(TOOLS.SELECT);
		}
	};
}
